
import state from './moduleGradeManagementState'
import mutations from './moduleGradeManagementMutations'
import actions from './moduleGradeManagementActions'
import getters from './moduleGradeManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

